export const Z_INDEX = {
  PROGRESS_BAR: 1003,
  SEARCH_POPOVER: 1002,
  HEADER_DROP_DOWN: 1001,
  HEADER_MENU: 1000,
  HEADER_PANEL: 1000,
  HEADER_MOBILE: 1000,
  // 1000 enforced by leaflet
};
